<template>
    <v-card class="mt-3">
        <v-card-title>
            Category selector
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                <v-icon small
                    v-bind="attrs"
                    v-on="on"
                >
                    mdi-help-circle-outline
                </v-icon>
                </template>
                <span>Retrieve data for a specific category by clicking on the desired category</span>
            </v-tooltip>
        </v-card-title>
        <v-expansion-panels accordion>
            <v-expansion-panel>
            <v-expansion-panel-header>
                <div>Gas phase</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-list>
                    <v-list-item 
                    v-for="(gasPhaseItem, index) in gasPhaseItems"
                    v-bind:key="index">
                        <router-link :to="gasPhaseItem.link">{{gasPhaseItem.title}}</router-link>
                    </v-list-item>
                    </v-list>
            </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
            <v-expansion-panel-header>
                <div>Photolysis</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-list>
                    <v-list-item 
                    v-for="(photolysisItems, index) in photolysisItems"
                    v-bind:key="index">
                        <router-link :to="photolysisItems.link">{{photolysisItems.title}}</router-link>
                    </v-list-item>
                    </v-list>
            </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
            <v-expansion-panel-header>
                <div>Heterogeneous</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-list>
                    <v-list-item 
                    v-for="(heterogeneousItem, index) in heterogeneousItems"
                    v-bind:key="index">
                        <router-link :to="heterogeneousItem.link">{{heterogeneousItem.title}}</router-link>
                    </v-list-item>
                    </v-list>
            </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
            <v-expansion-panel-header>
                <div>Aqueous phase</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-list>
                    <v-list-item 
                    v-for="(aqueousPhaseItem, index) in aqueousPhaseItems"
                    v-bind:key="index">
                        <router-link :to="aqueousPhaseItem.link">{{aqueousPhaseItem.title}}</router-link>
                    </v-list-item>
                    </v-list>
            </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
</template>

<script>
export default {
  name: "CatalogueSelector",
    
  data () {
      return {
          gasPhaseItems: [
            { title: 'all', link: '/catalogue/classifications/gap' },
            { title: 'Ox species', link: '/catalogue/categories/Ox' },
            { title: 'HOx species', link: '/catalogue/categories/HOx' },
            { title: 'NOx species', link: '/catalogue/categories/NOx' },
            { title: 'SOx species', link: '/catalogue/categories/SOx' },
            { title: 'aromatic Ox', link: '/catalogue/categories/Ox_AROM' },
            { title: 'aromatic + Hox', link: '/catalogue/categories/HOx_AROM' },
            { title: 'aromatic NO3', link: '/catalogue/categories/NO3_AROM' },
            { title: 'organics Ox + VOC', link: '/catalogue/categories/Ox_VOC' },
            { title: 'organics HOx + VOC', link: '/catalogue/categories/HOx_VOC' },
            { title: 'organics NO3 + VOC', link: '/catalogue/categories/NO3_VOC' },
            { title: 'organics X + VOC', link: '/catalogue/categories/X_VOC' },
            { title: 'organic ClOx', link: '/catalogue/categories/oClOx' },
            { title: 'organic BrOx', link: '/catalogue/categories/oBrOx' },
            { title: 'organic FOx', link: '/catalogue/categories/oFOx' },
            { title: 'organic IOx', link: '/catalogue/categories/oIOx' },
            { title: 'organics peroxy radicals', link: '/catalogue/categories/ROO_' },
            { title: 'organics: alkoxy radicals', link: '/catalogue/categories/RO_' },
            { title: 'O2 + organic radicals', link: '/catalogue/categories/R_Oxygen' },
            { title: 'organic ClOx oxy radical', link: '/catalogue/categories/oRClOx' },
            { title: 'organic : aromatic radicals', link: '/catalogue/categories/AROM_RAD' },
            { title: 'inorganic fluorinated species', link: '/catalogue/categories/iFOx' },
            { title: 'inorganic chlorinated species', link: '/catalogue/categories/iClOx' },
            { title: 'inorganic brominated species', link: '/catalogue/categories/iBrOx' },
            { title: 'inorganic iodinated species', link: '/catalogue/categories/iIOx' },
            { title: 'Criegee intermediates', link: '/catalogue/categories/CGI_' },
          ],
          photolysisItems: [
            { title: 'all', link: '/catalogue/classifications/pho' },
            { title: 'Ox species', link: '/catalogue/categories/POx' },
            { title: 'HOx species', link: '/catalogue/categories/PHOx' },
            { title: 'NOx species', link: '/catalogue/categories/PNOx' },
            { title: 'organic species', link: '/catalogue/categories/P' },
            { title: 'fluorinated species', link: '/catalogue/categories/PF' },
            { title: 'chlorinated species', link: '/catalogue/categories/PCl' },
            { title: 'brominated species', link: '/catalogue/categories/PBr' },
            { title: 'iodinated species', link: '/catalogue/categories/PI' },
            { title: 'SOx species', link: '/catalogue/categories/PSOx' },
          ],
          heterogeneousItems: [
            { title: 'all', link: '/catalogue/classifications/het' },
            { title: 'ice', link: '/catalogue/categories/HI' },
            { title: 'mineral dust', link: '/catalogue/categories/MD' },
            { title: 'SAM/SAD/SAT', link: '/catalogue/categories/HSTD' },
            { title: 'NAT/NAD', link: '/catalogue/categories/HNDT' },
            { title: 'water', link: '/catalogue/categories/HET_H2OL_' },
            { title: 'aqueous halids', link: '/catalogue/categories/HET_SALTS_' },
            { title: 'other liquids', link: '/catalogue/categories/HET_O_' },
            { title: 'H2SO4', link: '/catalogue/categories/HET_SL_' },
            { title: 'organic surfaces', link: '/catalogue/categories/Het_Org' },
          ],
          aqueousPhaseItems: [
            { title: 'all', link: '/catalogue/classifications/aqp' },
            { title: 'systematic OH', link: '/catalogue/categories/AQ_OH_' },
            { title: 'Systematic OH + inorganics', link: '/catalogue/categories/AQ_OH_inorg_' },
            { title: 'Systematic NO3 + organics', link: '/catalogue/categories/AQ_NO3_org_' },
            { title: 'thematic glyoxal', link: '/catalogue/categories/AQ_TH1_GLYX_' },
            { title: 'thematic methyl glyoxal', link: '/catalogue/categories/AQ_TH1_MGLY_' },
            { title: 'thematic NO3', link: '/catalogue/categories/AQ_TH1_NO3_' },
            { title: 'thematic OH', link: '/catalogue/categories/AQ_TH1_OH_' },
          ]
      }
  }
}
</script>

<style scoped>
.v-list-item > a {
    text-decoration: none;
}
</style>